(function(){

  const MAIN_FORM_ID = 'product-form-main';
  let isSyncing = false; // Bandera para evitar loops de sincronización


    const ATC_BUTTON_DISABLE_MS = 3000;
  document.addEventListener('click', function (ev) {
    const btn = ev.target.closest('.product-form--atc-button');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('disabled');
    setTimeout(function () {
      btn.disabled = false;
      btn.classList.remove('disabled');
    }, ATC_BUTTON_DISABLE_MS);
  }, true);

  function getMainForm(){
    return document.getElementById(MAIN_FORM_ID) || document.querySelector('form[data-product-form]') || document.querySelector('form[action^="/cart"]');
  }

  const stickyVariantSelector = '.sticky-bar select[name="id"], .sticky-bar select.variant_selector';
  const stickyQtySelector = '.sticky-bar #quantity-selector__input-sticky, .sticky-bar input[data-quantity-input]';

  function copyStickyValuesToMainForm() {
    if (isSyncing) {
      console.log('[Sync] Skipping sticky→main sync - already syncing');
      return;
    }
    isSyncing = true;

    try {
      const mainForm = getMainForm();
      if (!mainForm) {
        isSyncing = false;
        return;
      }

      const stickySel = document.querySelector(stickyVariantSelector);
      const stickyVal = stickySel && stickySel.value ? String(stickySel.value) : null;

      if (stickyVal && stickyVal !== 'not-selected') {
        console.log('[Sync] Copying sticky value to main form:', stickyVal);

        // 1. Update variant-selection custom element
        const variantSelection = mainForm.querySelector('variant-selection');
        if (variantSelection) {
          variantSelection.setAttribute('variant', stickyVal);
        }

        // 2. Update main select
        const mainSelect = mainForm.querySelector('select[name="id"]');
        if (mainSelect && String(mainSelect.value) !== stickyVal) {
          mainSelect.value = stickyVal;
          mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // 3. Update dropdowns and swatches in options-selection
        if (variantSelection) {
          const optionsSelection = variantSelection.querySelector('options-selection');
          if (optionsSelection) {
            const stickyOptions = stickySel.options[stickySel.selectedIndex];
            const variantTitle = stickyOptions ? stickyOptions.text.split(' - ')[0] : null;
            
            if (variantTitle) {
              const optionValues = variantTitle.split(' / ').map(v => v.trim());
              
              // Update each option (dropdown or swatch)
              optionValues.forEach((optionValue, index) => {
                // Find dropdown select for this option
                const selects = optionsSelection.querySelectorAll(`select[data-variant-option-index="${index}"]`);
                selects.forEach(select => {
                  const option = Array.from(select.options).find(opt => 
                    opt.value.trim().toLowerCase() === optionValue.trim().toLowerCase()
                  );
                  if (option && select.value !== option.value) {
                    select.value = option.value;
                    select.dispatchEvent(new Event('change', { bubbles: true }));
                  }
                });

                // Find radio/swatch for this option
                const radios = optionsSelection.querySelectorAll(
                  `input[type="radio"][data-variant-option-value-index="${index}"]`
                );
                radios.forEach(radio => {
                  if (radio.value.trim().toLowerCase() === optionValue.trim().toLowerCase()) {
                    if (!radio.checked) {
                      // Save scroll position to prevent auto-scroll
                      const scrollY = window.scrollY || window.pageYOffset;
                      const scrollX = window.scrollX || window.pageXOffset;
                      
                      radio.checked = true;
                      radio.dispatchEvent(new Event('change', { bubbles: true }));
                      
                      const label = radio.closest('label');
                      if (label) {
                        label.click();
                        // Restore scroll position after a brief moment
                        setTimeout(() => {
                          window.scrollTo(scrollX, scrollY);
                        }, 0);
                      }
                    }
                  }
                });
              });
            }
          }
        }

        // 4. Fallback: Si no hay select, usar input hidden
        if (!mainSelect) {
          let mainIdInput = mainForm.querySelector('input[name="id"]');
          if (!mainIdInput) {
            mainIdInput = document.createElement('input');
            mainIdInput.type = 'hidden';
            mainIdInput.name = 'id';
            mainIdInput.dataset.clonedFrom = 'sticky';
            mainForm.appendChild(mainIdInput);
          }
          if (String(mainIdInput.value) !== stickyVal) {
            console.log('[Sync] Updating main input:', stickyVal);
            mainIdInput.value = stickyVal;
            mainIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }

      // Copiar cantidad
      const stickyQty = document.querySelector(stickyQtySelector);
      const stickyQtyVal = stickyQty && stickyQty.value ? String(stickyQty.value) : null;
      if (stickyQtyVal) {
        let mainQty = mainForm.querySelector('input[name="quantity"]');
        if (!mainQty) {
          mainQty = document.createElement('input');
          mainQty.type = 'hidden';
          mainQty.name = 'quantity';
          mainQty.dataset.clonedFrom = 'sticky';
          mainForm.appendChild(mainQty);
        }
        if (String(mainQty.value) !== stickyQtyVal) {
          mainQty.value = stickyQtyVal;
        }
      }
    } finally {
      // Liberar la bandera después de un pequeño delay
      setTimeout(() => {
        isSyncing = false;
        console.log('[Sync] Sticky→Main sync completed, flag released');
      }, 100);
    }
  }

  function resolveVariantId(buttonContext) {
    const mainForm = getMainForm();

    if (mainForm) {
      try {
        const fd = new FormData(mainForm);
        const idFromFD = fd.get('id');
        if (idFromFD && idFromFD !== 'null' && idFromFD !== 'undefined' && idFromFD !== 'not-selected') {
          return String(idFromFD);
        }
      } catch(e){}
    }

    if (mainForm) {
      const sel = mainForm.querySelector('select[name="id"]');
      if (sel && sel.value && sel.value !== 'not-selected') return String(sel.value);
      const inp = mainForm.querySelector('input[name="id"]');
      if (inp && inp.value) return String(inp.value);
    }

    const variantWidget = document.querySelector('[data-variant-selection], variant-selection, [data-variant-selection-id]');
    if (variantWidget) {
      const attrVariant = variantWidget.getAttribute('variant') || variantWidget.dataset.variant;
      if (attrVariant) return String(attrVariant);

      const dataVariantsRaw = variantWidget.dataset && variantWidget.dataset.variants;
      if (dataVariantsRaw) {
        try {
          const vs = JSON.parse(dataVariantsRaw);
          const f = vs.find(v => v.available);
          if (f && f.id) return String(f.id);
        } catch(e){}
      }
    }

    const anyDataVariants = document.querySelector('[data-variants]');
    if (anyDataVariants) {
      try {
        const raw = anyDataVariants.getAttribute('data-variants') || anyDataVariants.dataset.variants;
        if (raw) {
          const vs = JSON.parse(raw);
          const f = vs.find(v => v.available);
          if (f && f.id) return String(f.id);
        }
      } catch(e){}
    }

    const stickySel = document.querySelector(stickyVariantSelector);
    if (stickySel && stickySel.value && stickySel.value !== 'not-selected') return String(stickySel.value);

    if (buttonContext && buttonContext.dataset) {
      if (buttonContext.dataset.defaultVariantId) return String(buttonContext.dataset.defaultVariantId);
      if (buttonContext.dataset.variants) {
        try {
          const vs = JSON.parse(buttonContext.dataset.variants);
          const f = vs.find(v => v.available);
          if (f && f.id) return String(f.id);
        } catch(e){}
      }
    }

    return null;
  }

  function collectPropertiesFromMainForm(){
    const props = {};
    const mainForm = getMainForm();
    if (!mainForm) return props;
    Array.from(mainForm.querySelectorAll('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]')).forEach(i=>{
      const m = i.name && i.name.match(/^properties\[(.+)\]$/);
      if (m) props[m[1]] = i.value;
    });
    return props;
  }

  function clearBundlePropsFromMainForm(mainForm) {
    if (!mainForm) return;
    mainForm.querySelectorAll('input[data-lectron-bundle-meta]').forEach(function (el) {
      el.remove();
    });
    const legacy = mainForm.querySelector('input[data-bundle-line-item-property]');
    if (legacy) legacy.remove();
  }

  function getSellingPlanFromMainForm(){
    const mainForm = getMainForm();
    if (!mainForm) return null;

    // Look for selling_plan input in main form or in sealsubs container
    const sellingPlanInput = mainForm.querySelector('input[name="selling_plan"]') ||
                            document.querySelector('.sealsubs-container input[name="selling_plan"]') ||
                            document.querySelector('input[data-sls-selling_plan]');

    if (sellingPlanInput && sellingPlanInput.value) {
      console.log('[STICKY-ATC] Found selling_plan:', sellingPlanInput.value);
      return sellingPlanInput.value;
    }

    console.log('[STICKY-ATC] No selling_plan found');
    return null;
  }

  async function openCartUI() {
    try {
      const triggers = [
        document.querySelector('[data-cart-drawer-open]'),
        document.querySelector('[data-open-cart]'),
        document.querySelector('.cart-toggle'),
        document.querySelector('.cart-drawer-toggle'),
        document.querySelector('.js-open-cart'),
        document.querySelector('[data-cart-button]'),
        document.querySelector('.header__icon--cart'),
      ];
      for (const t of triggers) {
        if (t) { t.click(); return true; }
      }

      const drawer = document.getElementById('cart-drawer') || document.querySelector('[data-cart-drawer], .cart-drawer, aside.cart-drawer');
      if (drawer) {
        drawer.classList.add('is-open', 'open');
        try { drawer.setAttribute('aria-hidden', 'false'); } catch(e){}
        const overlay = document.querySelector('.cart-drawer__overlay') || document.querySelector('[data-cart-drawer-overlay]');
        if (overlay) overlay.classList.remove('hidden');
        const focusable = drawer.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (focusable) focusable.focus();
        return true;
      }

      const ev = new CustomEvent('cart:open', { bubbles: true, cancelable: true });
      document.dispatchEvent(ev);

      window.location.href = '/cart';
      return false;
    } catch (err) {
      window.location.href = '/cart';
      return false;
    }
  }

  async function addItemAndRedirect({ id, quantity, properties, selling_plan }, redirectTo='/cart') {
    try {
      const itemData = {
        id: Number(id),
        quantity: Number(quantity)
      };

      if (properties && Object.keys(properties).length) {
        itemData.properties = properties;
      }

      if (selling_plan) {
        itemData.selling_plan = selling_plan;
      }

      console.log('[STICKY-ATC] Adding item to cart:', itemData);

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ items: [itemData] })
      });

      if (!res.ok) {
        const txt = await res.text();
        console.warn('[STICKY-ATC] Cart add failed:', res.status, txt);
        throw new Error(txt || 'cart add failed');
      }

      console.log('[STICKY-ATC] Cart add successful, opening cart UI');

      if (redirectTo === '/checkout') {
        window.location.href = '/checkout';
      } else {
        await openCartUI();
      }
    } catch (err) {
      console.warn('[STICKY-ATC] Error in addItemAndRedirect:', err);
    }
  }

  async function handleAdd(buttonEl, redirectTo='/cart') {
    copyStickyValuesToMainForm();
    const props = collectPropertiesFromMainForm();
    const selling_plan = getSellingPlanFromMainForm();
    const id = resolveVariantId(buttonEl);

    let qty = 1;
    const mainForm = getMainForm();
    if (mainForm) {
      const q = mainForm.querySelector('input[name="quantity"]');
      if (q && q.value) qty = Number(q.value);
    }
    if (!qty || qty <= 0) {
      const stickyQty = document.querySelector(stickyQtySelector);
      if (stickyQty && stickyQty.value) qty = Number(stickyQty.value);
    }

    if (!id) return;

    await addItemAndRedirect({ id, quantity: qty, properties: props, selling_plan }, redirectTo);
  }

  // Add to Cart button handler
  document.addEventListener('click', async function(e){
    const atcBtn = e.target.closest('.sticky-bar .product-form--atc-button, .sticky-bar-form .product-form--atc-button, [data-product-atc]');
    if (!atcBtn) return;

    // Check if this is actually in the sticky bar
    const isInStickyBar = atcBtn.closest('.sticky-bar, .sticky-bar-form');
    if (!isInStickyBar) {
      console.log('[STICKY-ATC] Button clicked but not in sticky bar, ignoring');
      return;
    }

    console.log('[STICKY-ATC] Processing sticky ATC button click');
    

    // Mark that we're handling this click to prevent other handlers
    window.__stickyAtcHandled = true;
    setTimeout(() => { delete window.__stickyAtcHandled; }, 100);

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    const extendOffer = document.querySelector('.extend-offer');
    const hasExtend = typeof ExtendShopify !== 'undefined' && extendOffer;
    
    copyStickyValuesToMainForm();
    await new Promise(resolve => setTimeout(resolve, 50));

    const selling_plan = getSellingPlanFromMainForm();
    const id = resolveVariantId(atcBtn);

    let qty = 1;
    const mainForm = getMainForm();
    if (mainForm) {
      const q = mainForm.querySelector('input[name="quantity"]');
      if (q && q.value) qty = Number(q.value);
    }
    if (!qty || qty <= 0) {
      const stickyQty = document.querySelector(stickyQtySelector);
      if (stickyQty && stickyQty.value) qty = Number(stickyQty.value);
    }

    if (!id) return;

    clearBundlePropsFromMainForm(getMainForm());
    const props = collectPropertiesFromMainForm();

    if (hasExtend) {
      ExtendShopify.handleAddToCart(extendOffer, {
        quantity: qty,
        modal: true,
        done: async function (plan) {
          copyStickyValuesToMainForm();
          clearBundlePropsFromMainForm(getMainForm());
          const propsInner = collectPropertiesFromMainForm();

          const items = [];
          const mainItem = { id: Number(id), quantity: qty };
          if (propsInner && Object.keys(propsInner).length > 0) {
            mainItem.properties = propsInner;
          }
          if (selling_plan) {
            mainItem.selling_plan = selling_plan;
          }
          items.push(mainItem);
          
          if (plan) {
            const warrantyVariantId = plan.variantId || plan.productVariantId || plan.id || plan.variantID;
            
            if (warrantyVariantId) {
              const warrantyItem = {
                id: Number(warrantyVariantId),
                quantity: qty,
                properties: { '_extend': 'true' }
              };
              
              if (plan.planId) warrantyItem.properties['_extendPlanId'] = plan.planId;
              if (plan.leadToken) warrantyItem.properties['Extend.LeadToken'] = plan.leadToken;
              
              items.push(warrantyItem);
            }
          }

          try {
            console.log('[STICKY-ATC] Adding items to cart with Extend warranty');
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: items })
            });

            if (response.ok) {
              console.log('[STICKY-ATC] Cart add successful with Extend, opening cart UI');
              await openCartUI();
            } else {
              console.warn('[STICKY-ATC] Cart add failed with Extend:', response.status, await response.text());
            }
          } catch (error) {
            console.warn('[STICKY-ATC] Error adding to cart with Extend:', error);
          }
        }
      });
      
    } else {
      await addItemAndRedirect({ id, quantity: qty, properties: props, selling_plan }, '/cart');
    }
  }, true);

  // Main form submit handler
  (function attachMainFormIntercept(){
    const mf = getMainForm();
    if (!mf) {
      const mo = new MutationObserver((mut, obs) => {
        if (getMainForm()) {
          obs.disconnect();
          attachMainFormIntercept();
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
      return;
    }
    const f = getMainForm();
    f.addEventListener('submit', function(e){
      e.preventDefault();
      e.stopPropagation();
      handleAdd(null, '/cart');
    }, true);
  })();

  // Sincronizar main form con sticky bar (dirección opuesta)
  function copyMainFormValuesToSticky() {
    if (isSyncing) {
      console.log('[Sync] Skipping main→sticky sync - already syncing');
      return;
    }
    isSyncing = true;

    try {
      const mainForm = getMainForm();
      if (!mainForm) {
        isSyncing = false;
        return;
      }

      const stickySel = document.querySelector(stickyVariantSelector);
      if (!stickySel) {
        isSyncing = false;
        return;
      }

      // Obtener el valor del main form - priorizar variant-selection custom element
      let mainVal = null;

      // 1. Intentar desde variant-selection custom element
      const variantSelection = mainForm.querySelector('variant-selection');
      if (variantSelection) {
        const variantAttr = variantSelection.getAttribute('variant');
        if (variantAttr && variantAttr !== 'not-selected') {
          mainVal = String(variantAttr);
        }
      }

      // 2. Si no hay variant-selection, buscar en select
      if (!mainVal) {
        const mainSelect = mainForm.querySelector('select[name="id"]');
        if (mainSelect && mainSelect.value && mainSelect.value !== 'not-selected') {
          mainVal = String(mainSelect.value);
        }
      }

      // 3. Si no hay select, buscar en input hidden
      if (!mainVal) {
        const mainInput = mainForm.querySelector('input[name="id"]');
        if (mainInput && mainInput.value && mainInput.value !== 'not-selected') {
          mainVal = String(mainInput.value);
        }
      }

      // Actualizar sticky solo si el valor es diferente y válido
      if (mainVal && mainVal !== 'not-selected' && String(stickySel.value) !== mainVal) {
        // Verificar que la opción existe en el sticky select
        const option = stickySel.querySelector(`option[value="${mainVal}"]`);
        if (option) {
          console.log('[Sync] Copying main form value to sticky:', mainVal);
          stickySel.value = mainVal;
          // NO disparar evento change aquí para evitar loop
        }
      }
    } finally {
      // Liberar la bandera después de un pequeño delay
      setTimeout(() => {
        isSyncing = false;
        console.log('[Sync] Main→Sticky sync completed, flag released');
      }, 100);
    }
  }

  // Sincronizar sticky bar con main form
  function setupStickySync() {
    const stickyVariantSelect = document.querySelector(stickyVariantSelector);
    const stickyQtyInput = document.querySelector(stickyQtySelector);

    // Sticky → Main Form (using event delegation to catch dynamically added elements)
    // Listen for changes on sticky variant select (event delegation)
    document.addEventListener('change', function(e) {
      const target = e.target;
      if (target && target.matches && target.matches(stickyVariantSelector)) {
        console.log('[Sync] Sticky variant select changed:', target.value);
        copyStickyValuesToMainForm();
      }
    }, true);

    // Also attach directly if element exists
    if (stickyVariantSelect) {
      stickyVariantSelect.addEventListener('change', function() {
        console.log('[Sync] Sticky variant select changed (direct):', stickyVariantSelect.value);
        copyStickyValuesToMainForm();
      });
    }

    // Listen for input/change on sticky quantity (event delegation)
    document.addEventListener('input', function(e) {
      const target = e.target;
      if (target && target.matches && target.matches(stickyQtySelector)) {
        console.log('[Sync] Sticky quantity input changed:', target.value);
        copyStickyValuesToMainForm();
      }
    }, true);

    document.addEventListener('change', function(e) {
      const target = e.target;
      if (target && target.matches && target.matches(stickyQtySelector)) {
        console.log('[Sync] Sticky quantity changed:', target.value);
        copyStickyValuesToMainForm();
      }
    }, true);

    // Also attach directly if element exists
    if (stickyQtyInput) {
      stickyQtyInput.addEventListener('input', function() {
        copyStickyValuesToMainForm();
      });
      stickyQtyInput.addEventListener('change', function() {
        copyStickyValuesToMainForm();
      });
    }

    // Main Form → Sticky
    const mainForm = getMainForm();
    if (mainForm) {
      // 1. Escuchar el custom element variant-selection (PRINCIPAL)
      const variantSelection = mainForm.querySelector('variant-selection');
      if (variantSelection) {
        // Escuchar el evento variant-change que dispara el custom element
        variantSelection.addEventListener('variant-change', function(e) {
          console.log('[Sync] variant-change event detected:', e.detail);
          setTimeout(() => copyMainFormValuesToSticky(), 50);
        });

        // Observar cambios en el atributo 'variant' del custom element
        const variantObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'variant') {
              console.log('[Sync] variant attribute changed:', variantSelection.getAttribute('variant'));
              copyMainFormValuesToSticky();
            }
          });
        });
        variantObserver.observe(variantSelection, { attributes: true, attributeFilter: ['variant'] });
      }

      // 2. Escuchar cambios en el select principal (fallback)
      const mainSelect = mainForm.querySelector('select[name="id"]');
      if (mainSelect) {
        mainSelect.addEventListener('change', function() {
          console.log('[Sync] main select changed:', mainSelect.value);
          copyMainFormValuesToSticky();
        });
      }

      // 3. Escuchar cambios en input hidden (fallback)
      const mainInput = mainForm.querySelector('input[name="id"]');
      if (mainInput) {
        const inputObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
              console.log('[Sync] input value changed:', mainInput.value);
              copyMainFormValuesToSticky();
            }
          });
        });
        inputObserver.observe(mainInput, { attributes: true });

        mainInput.addEventListener('change', function() {
          console.log('[Sync] input change event:', mainInput.value);
          copyMainFormValuesToSticky();
        });
      }

      // 4. Escuchar cambios en el formulario completo (fallback)
      mainForm.addEventListener('change', function(e) {
        if (e.target && e.target.name === 'id') {
          console.log('[Sync] form change event for id:', e.target.value);
          copyMainFormValuesToSticky();
        }
      });
    }

    // 5. Escuchar eventos personalizados (legacy support)
    document.addEventListener('variant:change', function() {
      console.log('[Sync] variant:change event detected');
      copyMainFormValuesToSticky();
    });

    // Sincronización inicial
    setTimeout(() => {
      console.log('[Sync] Initial sync');
      copyMainFormValuesToSticky();
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupStickySync);
  } else {
    setupStickySync();
  }

  (function toggleStickyClassPastActionWrapper() {
    const stickyForm = document.querySelector('body');
    if (!stickyForm) return;

    const triggerSelector = 'body .product__container--two-columns .product-form__action-wrapper';
    const className = 'is-past-main-action-wrapper';

    const updateStickyClass = () => {
      const triggerEl = document.querySelector(triggerSelector);
      if (!triggerEl) {
        stickyForm.classList.remove(className);
        return;
      }

      const triggerBottom = triggerEl.getBoundingClientRect().bottom + window.scrollY;
      const hasPassed = window.scrollY > triggerBottom;
      stickyForm.classList.toggle(className, hasPassed);
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        updateStickyClass();
        ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateStickyClass);
    window.addEventListener('load', updateStickyClass, { once: true });
    updateStickyClass();
  })();

  // Buy Now handler
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-buy-now]');
    if (!btn) return;
    
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    copyStickyValuesToMainForm();
    await new Promise(resolve => setTimeout(resolve, 50));

    const stickyVariantSelect = document.querySelector(stickyVariantSelector);
    const stickyQtyInput = document.querySelector(stickyQtySelector);
    
    let id = stickyVariantSelect ? stickyVariantSelect.value : null;
    
    if (!id || id === 'null' || id === 'undefined' || id === 'not-selected') {
      const mainForm = getMainForm();
      if (mainForm) {
        const mainSelect = mainForm.querySelector('select[name="id"]');
        if (mainSelect && mainSelect.value) {
          id = mainSelect.value;
        }
      }
    }
    
    if (!id || id === 'null' || id === 'undefined' || id === 'not-selected') {
      id = btn.dataset.defaultVariantId;
    }
    
    if ((!id || id === 'null' || id === 'undefined') && btn.dataset.variants) {
      try {
        const variants = JSON.parse(btn.dataset.variants);
        const firstAvailable = variants.find(v => v.available);
        if (firstAvailable) {
          id = String(firstAvailable.id);
        }
      } catch(_) {}
    }

    if (!id || id === 'not-selected') return;

    let qty = parseInt(stickyQtyInput?.value || '1', 10);
    
    if (!qty || qty <= 0) {
      const mainForm = getMainForm();
      if (mainForm) {
        const mainQty = mainForm.querySelector('input[name="quantity"]');
        if (mainQty && mainQty.value) {
          qty = parseInt(mainQty.value, 10);
        }
      }
    }

    if (!qty || qty <= 0) qty = 1;

    const extendOffer = document.querySelector('.extend-offer');
    const hasExtend = typeof ExtendShopify !== 'undefined' && extendOffer;

    try {
      await fetch('/cart/clear.js', { 
        method: 'POST', 
        headers: { 'Content-Type':'application/json' } 
      });
      
      await new Promise(resolve => setTimeout(resolve, 150));

      clearBundlePropsFromMainForm(getMainForm());
      const props = collectPropertiesFromMainForm();

      if (hasExtend) {
        ExtendShopify.handleAddToCart(extendOffer, {
          quantity: qty,
          modal: false,
          done: function (plan) {
            clearBundlePropsFromMainForm(getMainForm());
            const propsInner = collectPropertiesFromMainForm();

            const items = [{ id: Number(id), quantity: qty }];
            if (propsInner && Object.keys(propsInner).length > 0) {
              items[0].properties = propsInner;
            }
            
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: items })
            }).then(response => {
              if (response.ok) {
                window.location.href = '/checkout';
              } else {
                window.location.href = '/cart';
              }
            }).catch(() => {
              window.location.href = '/cart';
            });
          }
        });
        
      } else {
        const items = [{ id: Number(id), quantity: qty }];
        if (props && Object.keys(props).length > 0) {
          items[0].properties = props;
        }

        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });

        if (addRes.ok) {
          window.location.href = '/checkout';
        }
      }
      
    } catch (err) {
      // Error handling
    }
  }, true);

})();

(function clonePaymentTermsToSticky() {
  const STICKY_CONTAINER_SELECTOR = '.sticky-bar-price .variant-drop-down';
  const MAIN_FORM_SELECTOR = '#product-form-main';

  function findAndClone() {
    const mainForm = document.querySelector(MAIN_FORM_SELECTOR);
    const stickyContainer = document.querySelector(STICKY_CONTAINER_SELECTOR);
    if (!mainForm || !stickyContainer) return false;

    const original = mainForm.querySelector('shopify-payment-terms, [data-shopify-payment-terms], .shopify-payment-terms');
    if (!original) return false;

    const existing = stickyContainer.querySelector('shopify-payment-terms, [data-shopify-payment-terms], .shopify-payment-terms');
    if (existing) {
      existing.replaceWith(original.cloneNode(true));
    } else {
      stickyContainer.appendChild(original.cloneNode(true));
    }
    return true;
  }

  function tryUntilSuccess(timeout = 5000) {
    if (findAndClone()) return;
    const start = Date.now();
    const mo = new MutationObserver(() => {
      if (findAndClone() || Date.now() - start > timeout) mo.disconnect();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryUntilSuccess);
  } else {
    tryUntilSuccess();
  }

  document.addEventListener('variant:change', () => { tryUntilSuccess(); });
})();

// Sincronizar precio del main form al sticky bar cuando cambia (ej: suscripción)
(function syncPricingToSticky() {
  function setupPricingSync() {
    const mainPricing = document.querySelector('.product-main [data-product-pricing]');
    const stickyPricing = document.querySelector('.sticky-bar-form [data-product-pricing]');

    if (!mainPricing || !stickyPricing) {
      console.log('[STICKY-PRICING] Main or sticky pricing not found yet');
      return false;
    }

    console.log('[STICKY-PRICING] Setting up price synchronization');

    // Función para copiar el contenido de precio
    function syncPrice() {
      if (!mainPricing || !stickyPricing) return;

      // Clonar el contenido completo del pricing del main form
      const clonedContent = mainPricing.cloneNode(true);

      // Reemplazar el contenido del sticky bar
      stickyPricing.innerHTML = clonedContent.innerHTML;

      console.log('[STICKY-PRICING] Price synced to sticky bar');
    }

    // Sincronizar inicialmente
    syncPrice();

    // Observar cambios en el precio del main form
    const observer = new MutationObserver((mutations) => {
      syncPrice();
    });

    observer.observe(mainPricing, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: false
    });

    return true;
  }

  // Intentar configurar la sincronización
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(setupPricingSync, 100);
    });
  } else {
    setTimeout(setupPricingSync, 100);
  }

  // También intentar cuando cambie la variante
  document.addEventListener('variant:change', () => {
    setTimeout(setupPricingSync, 100);
  });

  (function () {
  const sourceSelector = '.product-form--atc .product-form--atc-button';
  const targetSelector = '.sticky-bar .product-form--atc-button.mdc-ripple-surface.mdc-ripple-upgraded';

  document.addEventListener('click', function (e) {
    const sourceBtn = e.target.closest(sourceSelector);
    if (!sourceBtn) return;

    // Stop existing click behavior completely
    e.preventDefault();
    e.stopImmediatePropagation();

    const targetBtn = document.querySelector(targetSelector);
    if (targetBtn) {
      targetBtn.click();
    } else {
      console.warn('Sticky ATC button not found:', targetSelector);
    }
  }, true); // use capture phase to intercept before other handlers
})();

})();